module.exports = __webpack_public_path__ + "assets/img/teacher (14).3b5db8fb.png";